<template>
  <div class="indexhome" :class="{'pc': !isPhone}">
    <pcheader v-show="!isPhone"></pcheader>
    <div class="homebg" v-show="isPhone"><img src="@/assets/images/indexbg.jpg" alt=""></div>
    <div class="homelogo" v-show="isPhone">
      <img class="animated fadeIn" src="@/assets/images/indexlogo.png" alt="">
      <p class="museumname">{{museumname}}</p>
    </div>
    <!--<div class="changemuseum" v-show="!isShow">-->
    <!--<a @click.stop="popshow" :class="{on: ison}">选择博物馆</a>-->
    <!--<div class="pop" v-show="popdisplay">-->
    <!--<div class="museumlist">-->
    <!--<ul>-->
    <!--<li v-for="(item, index) in codeList" :key="index" @click.stop="changemuseum(item)">{{item.value}}</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <div class="homelink animated fadeIn delay-1s" v-show="isPhone">
      <a @click.stop="addvolunteer">志愿者招募</a>
      <a @click.stop="volunteeractivity">志愿者活动</a>
      <!--<a>相关报道</a>-->
    </div>
    <div class="sidebar" :class="{'on': isnotice, 'pc': !isPhone}">
      <button class="title" @click.stop="notice">志愿者须知</button>
      <div class="content">
        <div class="innerbox">
          <div class="imgbox" v-show="titleImageshow"><img :src="titleImage" alt=""></div>
          <div class="desc" v-html="museumIntroduce"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { museuminfo } from '@/api/volunteer'
import Pcheader from '@/views/common/pcheader'
export default {
  name: 'home',
  components: {
    Pcheader
  },
  data () {
    return {
      isnotice: false,
      museumIntroduce: '',
      titleImage: '',
      isShow: false,
      popdisplay: false,
      codeList: [],
      museumname: '',
      museumCode: '',
      titleImageshow: true,
      ison: false,
      isPhone: false, // 是否是PC端/移动端
      screenWidth: 0 // 屏幕分辨率
    }
  },
  created () {
  },
  watch: {
    museumCode (val) {
      if (val) {
        this.getvolunteerinfo()
      }
    }
  },
  mounted () {
    // 判断是否从微信端进入
    if (this.getQueryStringRegExp('token') === '') {
      this.$cookie.set('weixinflag', 'false')
    } else {
      this.$cookie.set('weixinflag', 'true')
    }
    this.museumCode = this.getQueryStringRegExp('museumCode')
    this.$cookie.set('museumCode', this.getQueryStringRegExp('museumCode'))
    this.isShow = true
    this.screenWidth = document.body.clientWidth
    if (this.screenWidth < 768) {
      this.isPhone = true
    } else {
      this.isPhone = false
    }
    let _this = this
    window.onresize = () => {
      _this.screenResize()
    }
  },
  methods: {
    screenResize () {
      if (document.body.clientWidth < 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    // 获取地址栏参数
    getQueryStringRegExp (name) {
      var reg = new RegExp('(^|\\?|&)' + name + '=([^&]*)(\\s|&|$)', 'i')
      if (reg.test(location.href)) {
        return unescape(RegExp.$2.replace(/\+/g, ' '))
      } else {
        return ''
      }
    },
    notice () {
      this.isnotice = !this.isnotice
    },
    // 获取全部场馆名称和编码
    // getrootdepartmentcode () {
    //   this.$http({
    //     url: this.$http.adornUrl(`/api/admin/group/root-department-code`),
    //     method: 'get'
    //   }).then((res) => {
    //     if (res.data.rel === true) {
    //       let obj = res.data.data
    //       for (let i in obj) {
    //         let newobj = {}
    //         newobj.key = i
    //         newobj.value = obj[i]
    //         this.codeList.push(newobj)
    //       }
    //     }
    //   })
    // },

    // 选择场馆
    changemuseum (val) {
      this.popdisplay = false
      this.isShow = true
      this.museumCode = val.key
      this.museumname = val.value
    },
    addvolunteer () {
      this.$http({
        url: this.$http.adornUrl(`/api/volunteer/web/volunteer/service-info`),
        method: 'get'
      }).then((res) => {
        if (res) {
          if (res.data.rel === true) {
            if (res.data.data === '') {
              this.$router.push({path: '/volunteermuseum', query: {museumCode: this.museumCode}})
            } else {
              this.$router.push({path: '/volunteerinfomuseumedit', query: {museumCode: this.museumCode}})
            }
          } else {
            if (res.data.data === '你没有志愿者信息。') {
              this.$router.push({path: '/volunteerinfo', query: {museumCode: this.museumCode}})
            }
          }
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    // 跳转志愿者活动
    volunteeractivity () {
      this.$router.push({
        path: `/volunteeractivity`,
        query: {museumCode: this.museumCode}
      })
    },
    // 获取场馆志愿者须知
    getvolunteerinfo () {
      museuminfo({museumCode: this.museumCode}).then(response => {
        let data = response.data
        if (data.rel === true) {
          this.titleImageshow = true
          this.museumIntroduce = data.data.museumIntroduce
          this.titleImage = window.SITE_CONFIG.baseUrl + '/api/volunteer/web/images/' + data.data.titleImage
        } else {
          if (data.data === undefined) {
            this.museumIntroduce = '暂无须知'
            this.titleImage = ''
            this.titleImageshow = false
          }
        }
      })
    },
    // 显示选择场馆弹窗
    popshow () {
      this.popdisplay = true
      this.ison = true
    }
  }
}
</script>

<style lang="scss">
  .indexhome{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    .homebg{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .homelogo{
      position: absolute;
      z-index: 1;
      width: 50%;
      left: 50%;
      margin: 30% 0 0 -25%;
      img{
        width: 100%;
      }
      .museumname{
        color: #fff;
        text-align: center;
      }
    }
    .homelink{
      width: 100%;
      position: absolute;
      bottom: 6%;
      left: 0;
      text-align: center;
      a{
        display: inline-block;
        color: #fff;
        height: 34px;
        line-height: 34px;
        padding: 0 25px;
        border: solid 1px #fff;
        -webkit-border-radius: 18px;
        -moz-border-radius: 18px;
        border-radius: 18px;
        margin: 0 10px;
      }
    }
    .sidebar{
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: calc(100% - 36px);
      left: -webkit-calc(100% - 36px);
      z-index: 2;
      width: 100%;
      transition: left 0.3s;
      -moz-transition: left 0.3s;
      -webkit-transition: left 0.3s;
      -o-transition: left 0.3s;
      overflow: hidden;
      .title{
        display: block;
        cursor: pointer;
        position: absolute;
        top: 100px;
        width: 36px;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        background: #fff;
        padding: 18px 5px;
        font-size: 16px;
        text-align: center;
        color: #891d1c;
        font-weight: bold;
        line-height: 20px;
        z-index: 2222;
      }
      .content{
        padding-left: 36px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        overflow-y: auto;
        .imgbox{
          margin-bottom: 10px;
          img{
            width: 100%;
            height: auto;
          }
        }
        .innerbox{
          background: #fff;
          border-top-left-radius: 6px;
          border-bottom-left-radius: 6px;
          height: 100%;
          overflow: hidden;
          overflow-y: auto;
          padding: 20px 30px 20px;
        }
      }
      &.on{
        left: 0;
      }
      &.pc{
        position: absolute;
        top: 90px;
        bottom: 0px;
        left: 0;
        right: 0;
        overflow-y: auto;
        padding: 30px 0;
        .title{
          display: none;
        }
        .content{
          width: 1200px;
          margin: 0 auto;
          height: auto;
          overflow: visible;
          padding: 0;
          .innerbox{
            height: auto;
            overflow: visible;
            .imgbox{
              margin-bottom: 20px;
              img{
                display: block;
                width: 50%;
                margin: 0 auto;
              }
            }
          }
        }
      }
    }
    .changemuseum{
      width: 100%;
      position: fixed;
      bottom: 6%;
      left: 0;
      text-align: center;
      z-index: 10;
      height: 36px;
      .pop{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 60%;
        left: 50%;
        margin-left: -30%;
        height: 200px;
        z-index: 0;
        padding: 0 0 36px;
        overflow: hidden;
        border-top-left-radius: 18px;
        border-top-right-radius: 18px;
        &:after,&:before{
          display: block;
          content: '';
          height: 28px;
          width: 100%;
          position: absolute;
          left: 0;
          z-index: 2;
        }
        &:before{
          top: 0;
          background: -webkit-linear-gradient(top, rgba(255,255,255,1), rgba(255,255,255,0.5)); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(bottom, rgba(255,255,255,1), rgba(255,255,255,0.5)); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(bottom,rgba(255,255,255,1), rgba(255,255,255,0.5)); /* Firefox 3.6 - 15 */
          background: linear-gradient(to bottom, rgba(255,255,255,1) , rgba(255,255,255,0.5)); /* 标准的语法 */
          filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=rgba(255,255,255,1), endColorstr=rgba(255,255,255,0.5));
        }
        &:after{
          bottom: 36px;
          background: -webkit-linear-gradient(top, rgba(255,255,255,0.5), rgba(255,255,255,1)); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(bottom, rgba(255,255,255,0.5), rgba(255,255,255,1)); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(bottom, rgba(255,255,255,0.5), rgba(255,255,255,1)); /* Firefox 3.6 - 15 */
          background: linear-gradient(to bottom, rgba(255,255,255,0.5), rgba(255,255,255,1)); /* 标准的语法 */
          filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=rgba(255,255,255,0.5), endColorstr=rgba(255,255,255,1));
        }
        .museumlist{
          background: #fff;
          overflow: hidden;
          overflow-y: auto;
          ul{
            height: 164px;
            padding: 15px 0px;
            position: relative;
            overflow-y: auto;
            li{
              height: 30px;
              padding: 0 20px;
              line-height: 30px;
              text-align: left;
            }
          }
        }
      }
      a{
        position: absolute;
        display: inline-block;
        color: #fff;
        height: 36px;
        line-height: 36px;
        width: 60%;
        left: 50%;
        margin-left: -30%;
        border: solid 1px #fff;
        -webkit-border-radius: 18px;
        -moz-border-radius: 18px;
        border-radius: 18px;
        z-index: 2;
        &.on{
          border-top-right-radius: 0;
          border-top-left-radius: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue